import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { BasicDrawer } from '@/components/ui/basic-drawer';

import { ProcessCase } from './process-case';

export function ProcessCasePage() {
  const navigate = useNavigate();
  const { caseId } = useParams();
  const [params] = useSearchParams();

  const onClose = () => {
    navigate(-1);
  };

  return (
    <BasicDrawer open={true} onClose={onClose}>
      {caseId ? (
        <ProcessCase caseId={caseId} isNewCase={Boolean(params.get('new-case'))} />
      ) : (
        <div className="flex flex-col items-center justify-center h-full">
          <h2 className="text-xl font-bold">Error: Case ID is missing</h2>
          <p>Please provide a valid case ID to upload images.</p>
        </div>
      )}
    </BasicDrawer>
  );
}
